import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Icon({ className, children, item }) {
    const { icon = {} } = item;
    const { icon: iconArgs } = icon;

    return (
        <div className={className}>
            {iconArgs && (
                <FontAwesomeIcon
                    className="icon"
                    icon={[iconArgs.prefix, iconArgs.iconName]}
                />
            )}
            <span>{children}</span>
        </div>
    );
}

export default React.memo(Icon);
